/**
 * Конфигурация колонок таблицы
 */
import { Tag } from "antd";
import * as React from "react";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";

import { roleColors, statusColors } from "./constants";
import { User } from "./types";

/**
 * Создает конфигурацию колонок для таблицы пользователей
 */
export const createColumns = (): RtColumn<User>[] => [
  {
    key: "id",
    title: "ID",
    width: "80px",
    sort: true,
    align: "center",
    render: (row) => `#${row.id}`,
  },
  {
    key: "name",
    title: "Имя",
    width: "30%",
    minWidth: 150,
    sort: true,
    render: (row) => row.name,
  },
  {
    key: "email",
    title: "Email",
    sort: true,
    render: (row) => row.email,
  },
  {
    key: "role",
    title: "Роль",
    // width: "20%",
    sort: true,
    align: "center",
    render: (row) => (
      <Tag color={roleColors[row.role]}>{row.role.toUpperCase()}</Tag>
    ),
  },
  {
    key: "age",
    title: "Возраст",
    // width: 100,
    sort: true,
    align: "center",
    render: (row) => row.age,
  },
  {
    key: "status",
    title: "Статус",
    // width: 120,
    sort: true,
    align: "center",
    render: (row) => <Tag color={statusColors[row.status]}>{row.status}</Tag>,
  },
  {
    key: "createdAt",
    title: "Дата создания",
    // width: 500,
    sort: true,
    render: (row) => row.createdAt,
  },
];
